// import { useRef } from 'react';
import { useEffect, useState } from 'react';
import '@lottiefiles/lottie-player';

export default function AllImg(props) {
  const [fileType, setFileType] = useState('');

  useEffect(() => {
    setFileType(getFileType(props.src))
  }, [props.src])

  function getFileType(src) {
    var srcExt = '';

    if (src) {
      const lastSlashIndex = src.lastIndexOf('/');
      const filename = lastSlashIndex !== -1 ? src.substring(lastSlashIndex + 1) : src;
      const lastDotIndex = filename.lastIndexOf('.');
      if ((lastDotIndex > 0) && (lastDotIndex < filename.length)) {
        srcExt = filename.substring(lastDotIndex + 1).toUpperCase()
      }
    }

    return srcExt;
  }

  /* 
  const ref = useRef();

  const onEnter = () => ref.current.play();
  const onLeave = () => ref.current.stop();

  useEffect(() => {
    const player = ref.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) player.play();
        else player.stop();
      },
      { threshold: 0.5 }
    );

    observer.observe(player);
    return () => observer.disconnect();
  }, []);
  */

  return (
  <div className="allimg-container">
    {(fileType === 'JSON') ? (
      <lottie-player
        src={props.src}
        class={['d-flex justify-content-center align-items-center', props.className].filter(Boolean).join(' ')}
        style={{...props.style}}
        loop={true}
        autoplay={true}
        /* 
        ref={ref}
        onMouseEnter={onEnter}
        onMouseLeave={onLeave} 
        */
        disableShadowDOM
      />
    ) : (fileType === 'SVG') ? (
      <object className={props.className} type="image/svg+xml" data={props.src} alt={props.alt} style={{...props.style}} >{props.alt}</object>
    ) : (getFileType(props.src) === 'MP4') ? (
      <video className={props.className} loop autoPlay muted playsInline>
        <source src={props.src} type="video/mp4"/>
      </video>
    ) : (['GIF','JPG','JPEG','PNG'].includes(fileType)) ? (
      <img className={props.className}  src={props.src} alt={props.alt} style={{...props.style}} />
    ) : (
      <>
      {/* <img className={props.className} src='/android-chrome-512x512.png' alt={props.alt} style={{...props.style}} /> */}
      </>
    )}
  </div>
  );
}
